module.exports = __webpack_public_path__ + "static/media/Workplace.5b2c67bf.svg";